<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">
            <div class="question">
                Please enter your <span>income</span>.
            </div>
            <div class="answer answer-col">
                <div v-for="(income, index) in otherIncomes" :key="otherIncomes[index].id">
                    <income v-model="otherIncomes[index]" @delete="deleteOtherIncome(income, index)" />

                    <div class="form-separator">&nbsp;</div>
                </div>

                <div class="add-new">
                    <v-btn fab small @click="addOtherIncome(personOne)">
                        <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                    Add another income
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    import Income from "@/components/questionnaire/Income";

    export default {
        name: 'Incomes',
        components: {
            GoBack,
            Income
        },
        mounted() {
            this.$store.dispatch('otherIncomes/loadOtherIncomes')
                .then(() => {
                    if (this.otherIncomes.length === 0) {
                        this.$store.commit('otherIncomes/addOtherIncome', this.personOne);
                    }
                });
        },
        methods: {
            next() {
                this.$store.dispatch('otherIncomes/saveOtherIncomes');
                this.$router.push({ name: 'HaveSavings' });
            },
            addOtherIncome(person) {
                this.$store.commit('otherIncomes/addOtherIncome', person);
            },
            deleteOtherIncome(otherIncome, index) {
                this.$store.dispatch('otherIncomes/deleteOtherIncome', { otherIncome: otherIncome, index: index });
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
            ]),
            ...mapGetters('otherIncomes', [
                'otherIncomes'
            ]),
        }
    }
</script>
